import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	comments: [],

	creating: false,
	deleting: false,
	updating: false,
	gettingList: false,
	gettingItem: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const CommentSlice = createSlice({
	name: 'comment',
	initialState,
	reducers: {

		onLoadCreate: (state, action ) => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ) => {
			return {...state, gettingList: true};
		},


		// Success
		onSuccessCreate: (state, action) => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action) => {
			return {...state, deleting: false};
		},

		onSuccessUpdate: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action) => {
			return {...state, comments: action.payload.data, gettingList: false};
		},

		// Errors
		onFailCreate: (state, action) => {
			return {...state, creating: false };
		},

		onFailDelete: (state, action) => {
			return {...state, deleting: false };
		},

		onFailUpdate: (state, action) => {
			return {...state, updating: false };
		},

		onFailList: (state, action) => {
			return {...state, comments: [] };
		},

	},
});
//
// export const {
// 	//...
// } = CommentSlice.actions;
